import {lazy} from 'react'

export { default as GiftShopRootScreen } from './GiftShopRootScreen'

const GiftShopRootLinkScreen = lazy(() => import('./GiftShopRootLinkScreen'))

export {GiftShopRootLinkScreen}
